import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { cyclopsComponent } from './cyclops/cyclops.component';

const routes: Routes = [
  {
    path: '',
    component: cyclopsComponent,
    data: {
      title: "cyclops"
    }
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutsRoutingModule { }
